export default __webpack_public_path__ + "static/media/item_4@2x.d2544206.png";